<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
  />
</template>

<script setup lang="ts">
interface IconModule { default: any } // Тип для загружаемого модуля
type IconComponent = IconModule['default']; // Тип для Vue-компонента

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
});

const iconComponent: Ref<IconComponent | null> = ref(null);

async function setIcon() {
  const iconName = `/components/icons/${props.icon}.vue`;
  const components = import.meta.glob('@/components/icons/*.vue') as Record<string, () => Promise<IconModule>>;
  if (components[iconName]) {
    const module = await components[iconName](); // Загружаем модуль
    iconComponent.value = markRaw(module.default); // Получаем Vue-компонент
  } else {
    console.error(`Icon "${iconName}" not found.`);
    iconComponent.value = null;
  }
}

setIcon();
</script>
